//@ts-nocheck

import * as React from 'react';
import { observer } from 'mobx-react';
import { Form } from 'react-final-form';
import { Secretariat } from '../../store/models/Secretariat';
import { Page, TLCode } from '../../common/enums';
import { Instance } from 'mobx-state-tree';
import { CheckboxInputFormField, TextInputFormField } from '../common/form';
import VerticalForm from '../common/form/VerticalForm';
import styled from '@emotion/styled';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { toJS } from 'mobx';
import LanguageFormField from '../common/form/LanguageFormField';
import SimpleTextFormContent from '../common/form/SimpleTextFormGroup';
import { Button, Intent } from '@blueprintjs/core';
import { Link } from 'react-router-dom';
import { TranslatedMessage } from '../common/translation';
import { IconNames } from '@blueprintjs/icons';
import LeaveRouteDirtyWrapper from '../common/LeaveRouteDirtyWrapper';

const Container = styled.div`
  display: flex;
  width: 70%;
  flex-direction: column;
`;

const ButtonsContainer = styled.div`
  display: flex;
  align-content: center;
  justify-content: flex-end;
  & button {
    margin-left: 5px;
  }
`;

const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  .bp3-button {
    margin-right: 3px;
  }
`;

const DivColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

const DivRightColumn = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: auto;
`;

interface SecretariatFormProps extends WithTranslateProps {
  secretariat?: Instance<typeof Secretariat>;
  save: (data: any) => void;
  readOnly: boolean;
}

interface SecretariatFormState {
  loading: boolean;
}

@observer
class SecretariatForm extends React.Component<SecretariatFormProps, SecretariatFormState> {
  constructor(props: SecretariatFormProps) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  public render() {
    const { secretariat, translate, save, readOnly } = this.props;
    return (
      <Form
        initialValues={toJS(secretariat) || {}}
        onSubmit={save}
        render={({ handleSubmit, form, hasValidationErrors, dirty }) => (
          <form onSubmit={handleSubmit}>
            <LeaveRouteDirtyWrapper blockChange={dirty} />
            <Container>
              <VerticalForm labelWidth={175}>
                <TextInputFormField
                  name="code"
                  label={TLCode.SECRETARIAT_Code}
                  inline={true}
                  fill={true}
                  required={true}
                  disabled={readOnly}
                />
                <TextInputFormField
                  name="name"
                  label={TLCode.SECRETARIAT_Name}
                  inline={true}
                  fill={true}
                  required={true}
                  disabled={readOnly}
                />
                <TextInputFormField
                  name="address"
                  label={TLCode.SECRETARIAT_Address}
                  inline={true}
                  fill={true}
                  disabled={readOnly}
                />
                <TextInputFormField
                  name="zipCode"
                  label={TLCode.SECRETARIAT_ZipCode}
                  inline={true}
                  fill={true}
                  disabled={readOnly}
                />
                <TextInputFormField
                  name="city"
                  label={TLCode.SECRETARIAT_City}
                  inline={true}
                  fill={true}
                  disabled={readOnly}
                />
                <TextInputFormField
                  name="website"
                  label={TLCode.SECRETARIAT_Website}
                  inline={true}
                  fill={true}
                  disabled={readOnly}
                />
                <TextInputFormField
                  name="phoneNumber"
                  label={TLCode.SECRETARIAT_PhoneNumber}
                  inline={true}
                  fill={true}
                  disabled={readOnly}
                />
                <TextInputFormField
                  name="mailAddress"
                  label={TLCode.SECRETARIAT_MailAddress}
                  inline={true}
                  fill={true}
                  disabled={readOnly}
                />
                <DivLine>
                  <DivColumn>
                    <LanguageFormField name="language" required={true} disabled={readOnly} />
                    <SimpleTextFormContent label={TLCode.IS_ACTIVE} small={false}>
                      <CheckboxInputFormField name="isActive" inline={true} required={false} disabled={readOnly} />
                    </SimpleTextFormContent>
                  </DivColumn>
                </DivLine>
              </VerticalForm>
              <ButtonsContainer>
                <Button>
                  <Link to={`${Page.Secretariats}`}>
                    <TranslatedMessage id={TLCode.BackToList} />
                  </Link>
                </Button>
                <Button
                  text={translate(TLCode.GENERAL_Cancel)}
                  icon={IconNames.ERASER}
                  intent={Intent.PRIMARY}
                  onClick={() => form.reset()}
                  disabled={!dirty || readOnly}
                />
                <Button
                  type={'submit'}
                  text={translate(TLCode.GENERAL_Save)}
                  icon={IconNames.FLOPPY_DISK}
                  intent={Intent.PRIMARY}
                  disabled={hasValidationErrors || !dirty || readOnly}
                />
              </ButtonsContainer>
            </Container>
          </form>
        )}
      />
    );
  }
}

export default withTranslate(SecretariatForm);
